import { ActionReducer } from '@ngrx/store';
import { PerformanceTracking } from '@shared/tracking';
import { TypedAction } from './actions';

const STORAGE_KEY = 'datastore_session_store_v9';

export function sessionStorageSyncFactory(
  performanceTracking: PerformanceTracking,
) {
  return (reducer: ActionReducer<any, TypedAction>) => {
    let firstState = true;
    let pendingWrite = false;
    return (state: any, action: TypedAction) => {
      let nextState = state;
      if (firstState) {
        try {
          performanceTracking.mark('read-session-storage-start');
          const sessionStorageState = JSON.parse(
            window.sessionStorage.getItem(STORAGE_KEY) || '{}',
          );
          performanceTracking.mark('read-session-storage-end');
          performanceTracking.measure(
            'read-session-storage',
            'read-session-storage-start',
            'read-session-storage-end',
          );
          nextState = {
            ...state,
            ...sessionStorageState,
          };
        } catch (e) {
          // ignore the errors, e.g. quota is full or security error
          console.error(e);
        }
      }
      firstState = false;
      const next = reducer(nextState, action);
      if (!pendingWrite) {
        pendingWrite = true;
        (<any>window).requestIdleCallback(() => {
          try {
            performanceTracking.mark('write-session-storage-start');
            window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
            performanceTracking.mark('write-session-storage-end');
            performanceTracking.measure(
              'write-session-storage',
              'write-session-storage-start',
              'write-session-storage-end',
            );
          } catch (e) {
            // ignore the errors, e.g. quota is full or security error
            console.error(e);
          }
          pendingWrite = false;
        });
      }

      return next;
    };
  };
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/core/session-storage-sync.reducer.ts